import { render, staticRenderFns } from "./HomePost.vue?vue&type=template&id=326e21e0&"
import script from "./HomePost.vue?vue&type=script&lang=js&"
export * from "./HomePost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports